import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { IntervalService } from '../interval/interval.service';
import { IdleService } from '../idle/idle.service';
import { AnalyticsService } from '../analytics/analytics.service';

@Injectable({
  providedIn: 'root'
})
export class AssistanceService {

  $magnifyingGlassActive = new BehaviorSubject<boolean>(false);
  $barrierFreeModeActive = new BehaviorSubject<boolean>(false);
  $highContrastModeActive = new BehaviorSubject<boolean>(false);
  $navigationLevel = new BehaviorSubject<number>(1);
  subscriptions = [];

  constructor(private idle: IdleService, private analytics: AnalyticsService) {
    this.subscriptions.push(this.idle.$idle.pipe(filter(Boolean)).subscribe(() => {
      this.reset();
    }));
  }

  public reset() {
    this.$magnifyingGlassActive.next(false);
    this.$barrierFreeModeActive.next(false);
    this.$highContrastModeActive.next(false);
  }

  handleBarrierfreeStatus(status, field = this.$magnifyingGlassActive, analyticsName = 'magnifyingGlass') {
    if (status === undefined) {
      status = !field.getValue();
    }
    if (status) {
      this.analytics.logPageAction('helper:' + analyticsName);
    }
    field.next(status);
  }

  public toggleMagnifyingGlass(status?: boolean) {
    this.handleBarrierfreeStatus(status);
  }

  public toggleHighContrastMode(status?: boolean) {
    this.handleBarrierfreeStatus(status, this.$highContrastModeActive, 'highContrast');
  }

  public toggleBarrierFreeMode(status?: boolean) {
    this.handleBarrierfreeStatus(status, this.$barrierFreeModeActive, 'barrierFree');
  }

  public setNavigationLevel(level: number) {
    this.$navigationLevel.next(level);
  }

  public scroll(direction: string, element: any, step: number): Promise<boolean> {
    return new Promise(resolve => {
      if (!element) return resolve(false);
      element.style.scrollSnapType = 'none';
      let i = 0, delta = direction === 'top' ? -1 : 1;
      IntervalService.set('scrollList', () => {
        element.scrollTop += delta;
        if (++i === step) {
          element.style.scrollSnapType = 'y mandatory';
          IntervalService.clear('scrollList');
          resolve(true);
        }
      }, 2);
    });
  }
}
